import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { useDispatch } from "react-redux";
import { updateList } from "../../../../store/actions/leads-list";

const EditListModal = ({ preview, selectedData, previewHandler }) => {
  // STATES
  const [isLoading, setLoading] = useState(false);

  // CONST VALS
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const { http } = global.services;
  const [form] = Form.useForm();

  // HANDLERS
  const submitHandler = (values) => {
    setLoading(true);
    const url = `user-lead-list/${selectedData.id}`;
    http
      .put(url, values)
      .finally(() => setLoading(false))
      .then(({ data }) => {
        toast.success("List updated successfully");
        dispatch(updateList(data));
        previewHandler();
        form.resetFields();
      })
      .catch((error) => {
        const message = error?.response?.data?.error || "Something went wrong";
        toast.error(message);
      });
  };

  // HOOKS
  useEffect(() => {
    if (selectedData) {
      inputRef.current?.focus();
      form.setFieldsValue({
        name: selectedData.name,
      });
    }
  }, [selectedData, preview]);

  return (
    <Modal
      visible={preview}
      centered
      className="add-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Update Leads List</h2>
      <p>Enter name of list below</p>
      <Form form={form} onFinish={submitHandler}>
        <label htmlFor="name">Name</label>
        <Form.Item
          name="name"
          rules={[
            { required: true, message: "List name is required" },
            {
              max: 100,
              message: "List name cannot be more than 100 characters",
            },
          ]}
        >
          <Input ref={inputRef} type="text" placeholder="Enter list name" />
        </Form.Item>
        <div className="action-box">
          <button type="button" onClick={previewHandler}>
            Cancel
          </button>
          <button className="submit" type="submit">
            {isLoading ? <BeatLoader size={8} color="#fff" /> : "Submit"}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditListModal;
